import { getSsoGroups } from 'ducks/ssoGroupManagement';
import { connect } from 'react-redux';
import SsoGroupList from './SsoGroupList';

const mapStateToProps = (state) => ({
  groups: state.ssoGroups.groups,
  ajaxStatus: state.ajax,
  localisation: state.localisation,
  appLoading: state.meta.appLoading,
});

const mapDispatchToProps = {
  getSsoGroups,
};

export default connect(mapStateToProps, mapDispatchToProps)(SsoGroupList);
